import { ComponentConstants } from './ComponentConstants';

/**
 * Certificate type constants for certificate verification
 * Maps user-friendly display names to component GUIDs
 */

export const CERTIFICATE_TYPES = {
  ENDORSEMENT: { display: 'Endorsement Certificate', componentId: ComponentConstants.ENDORSEMENTS },
  DEDICATED_STATUS: { display: 'Dedicated Status Certificate', componentId: ComponentConstants.DEDICATED_COURSES },
  ACTIVITY: { display: 'Activity Report', componentId: ComponentConstants.ACTIVITIES },
  MEMBERSHIP_CERTIFICATE: { display: 'Proof of Membership', componentId: ComponentConstants.MEMBERS },
  MEMBER_CARD: { display: 'Member Card', componentId: ComponentConstants.MEMBERS },
} as const;

/**
 * Get all certificate type options for dropdown display
 * @returns Array of certificate type options with display name and component ID
 */
export const getCertificateTypeOptions = () => {
  return Object.values(CERTIFICATE_TYPES);
};

/**
 * Get component ID from display name
 * @param displayName The display name shown to the user
 * @returns The component GUID, or undefined if not found
 */
export const getCertificateComponentId = (displayName: string): string | undefined => {
  const entry = Object.values(CERTIFICATE_TYPES).find(
    (cert) => cert.display === displayName
  );
  return entry?.componentId;
};

/**
 * Get display name from component ID
 * @param componentId The component GUID
 * @returns The user-friendly display name, or undefined if not found
 */
export const getCertificateTypeDisplay = (componentId: string): string | undefined => {
  const entry = Object.values(CERTIFICATE_TYPES).find(
    (cert) => cert.componentId.toLowerCase() === componentId.toLowerCase()
  );
  return entry?.display;
};
